import React from 'react';
import useTextOverlayAdvancedAnimation from '../../../useTextOverlayAdvancedAnimation';
import AnimationColorSelector from '../../AnimationColorSelector';

export interface KaraokeAnimationWordEmphasisColorSelectorProps {}

const KaraokeAnimationWordEmphasisColorSelector: React.FC<KaraokeAnimationWordEmphasisColorSelectorProps> = () => {
  const {
    selectedAdvancedAnimation,
    onAnimationPropertyChange,
  } = useTextOverlayAdvancedAnimation();

  return (
    <AnimationColorSelector
      title="active word color"
      color={selectedAdvancedAnimation?.properties?.wordEmphasisColor}
      onChange={color => onAnimationPropertyChange('wordEmphasisColor', color)}
    />
  );
};

export default KaraokeAnimationWordEmphasisColorSelector;
